import { Box } from '@fullstory/components';
import { Spinner } from '@fullstory/components/legacy/Spinner';
import React, { useContext, useMemo } from 'react';
import css from './ElementToImage.module.scss';
import { classNames } from '@fullstory/util/fmt';
import { CONTAINER_CLASS, IGNORE_FILTER_CLASS as EXCLUDE_FILTER_CLASS } from './constants';

interface ElementToImageProps {
  loading: boolean;
  setRef: (node: HTMLElement | null) => void;
}

interface ElementToImageContextValues {
  loading: boolean;
  setRef: (node: HTMLElement | null) => void;
}
export const ElementToImageContext = React.createContext<ElementToImageContextValues>({
  loading: false,
  setRef: () => {},
});

function ElementToImageContainer({
  loading,
  setRef,
  children,
  ...rest
}: React.PropsWithChildren<ElementToImageProps>) {
  const contextValue = useMemo(() => ({ setRef, loading }), [loading, setRef]);
  return (
    <Box style={{ position: 'relative' }}>
      <Box className={classNames(css.loadingSpinner, { [css.visible]: loading })}>
        <Spinner diameter={64} />
      </Box>

      <Box className={CONTAINER_CLASS} style={{ position: 'relative' }} {...rest}>
        <ElementToImageContext.Provider value={contextValue}>
          {children}
        </ElementToImageContext.Provider>
      </Box>
    </Box>
  );
}
ElementToImageContainer.displayName = 'ElementToImageContainer';

function ElementToImageExclude({ children }: React.PropsWithChildren<{}>) {
  return (
    <Box className={EXCLUDE_FILTER_CLASS} style={{ display: 'contents' }}>
      {children}
    </Box>
  );
}
ElementToImageExclude.displayName = 'ElementToImageExclude';

function ElementToImageTarget({ children }: React.PropsWithChildren<{}>) {
  const { setRef } = useContext<ElementToImageContextValues>(ElementToImageContext);
  return (
    <Box className={css.target} ref={setRef}>
      {children}
    </Box>
  );
}
ElementToImageTarget.displayName = 'ElementToImageTarget';

const ElementToImageWithStatics = {
  Container: ElementToImageContainer,
  Exclude: ElementToImageExclude,
  Target: ElementToImageTarget,
};

export { ElementToImageWithStatics as ElementToImage };
